// src/components/InventarioNavBar.js
import React from 'react';
import './InventarioNavBar.css'; // Archivo CSS para los estilos

const InventarioNavBar = ({ onSelectTab, activeTab }) => {

  const handleTabClick = (tabName) => {
    onSelectTab(tabName); // Llama a la función prop para comunicar el cambio al componente padre
  };

  return (
    <div className="inventario-nav-bar">
      <button
        className={`nav-tab ${activeTab === 'activos' ? 'active' : ''}`}
        onClick={() => handleTabClick('activos')}
      >
        Inventarios Cíclicos
      </button>
      <button
        className={`nav-tab ${activeTab === 'en-conteo' ? 'active' : ''}`}
        onClick={() => handleTabClick('en-conteo')}
      >
        Inventarios Generales
      </button>
      <button
        className={`nav-tab ${activeTab === 'subir' ? 'active' : ''}`}
        onClick={() => handleTabClick('subir')}
      >
        Registrar Inventario
      </button>
      {/* La pestaña de "Detalle de Inventarios" no es un tab fijo. 
        Se accederá a ella desde las vistas de "Activos" o "En Conteo".
        Podrías considerar un botón "Volver" dentro del componente DetalleInventario.
      */}
    </div>
  );
};

export default InventarioNavBar;